import React from "react";
import { Form, Label, List } from "semantic-ui-react";
import _uniqueId from "lodash/uniqueId";

/**
 *
 * @param errors
 * @param displayError
 * @returns {*}
 * @constructor
 * @return {null}
 */
interface RawErrorsProps {
  errors: Array<string>;
  id: string;
  options: any
};

const RawErrors: React.FC<RawErrorsProps> = ({ errors, id, options }) => {
  const { pointing, size } = options;

  const defaultProps = {
    prompt: true,
    pointing: "pointing",
    id: id ? `${id}-error-message` : undefined,
    role: "alert",
    "aria-atomic": true,
  };

  if (errors && errors.length > 0) {
    return (
      <Form.Field>
        <Label
          // color="red"
          {...defaultProps}
          pointing={pointing || "above"}
          size={size || "small"}
          basic
        >
          <List bulleted>
            {errors.map((error) => (
              <List.Item key={_uniqueId()} content={error} />
            ))}
          </List>
        </Label>
      </Form.Field>
    );
  }
  return null;
};

RawErrors.defaultProps = {
  options: {
    pointing: "above",
    size: "small",
  },
};

export default RawErrors;
